/**
 * Название поля ввода формы семейного положения.
 */
export enum Field {
  STATUS = 'status',
  SIZE = 'size',
  CHILDREN_COUNT = 'childrenCount',
  IS_LIVING_WITH_PARENTS = 'isLivingWithParents',
}
